export function getTheme() {
  return window.current_theme || window?.theme?.name;
}

export const theme = getTheme();
